/**
 * Auth token/header MECHANISM — Phase 6a-3 commit 9 of the decomposition
 * (briefs/ARCHITECTURE_DECOMPOSITION_BLUEPRINT.md §6, A5 pure subset,
 * v2.7/R23). Bodies moved VERBATIM from static/index.html; the three pages'
 * header-builders were verified byte-equivalent modulo variable names, so
 * this single copy serves index now, paper in 6a-8, live in 6a-9 at the
 * earliest.
 *
 * MECHANISM ONLY — deliberately NOT here (R23):
 *  - handleAuthFailure and every other 401 UX: the three pages deliberately
 *    differ (index: banner, token kept; paper: token cleared + auth overlay;
 *    live: none). Page-local permanently.
 *  - Token WRITERS (index logout removeItem, paper login set/clear): page
 *    flows own their writes; they share the key via AUTH_TOKEN_KEY below.
 *  - fetch: this module never performs HTTP. Callers keep calling
 *    window.fetch page-side, which preserves auth-refresh.js's 401-retry
 *    wrapper (H19) by construction.
 *
 * The token is read from localStorage AT CALL TIME, never cached — after
 * auth-refresh.js swaps in a fresh token, the very next authHeaders() call
 * picks it up. Zero module-level mutable state.
 */

/** Same key as auth-gate.js / auth-refresh.js / paper.html / live.html —
 * same origin, one login authenticates every tool page. */
export const AUTH_TOKEN_KEY = 'nikhilchart_auth_token';

/** Merge Authorization into `extra` (never mutated); no header when logged out. */
export function authHeaders(extra?: Record<string, string>): Record<string, string> {
  const t = localStorage.getItem(AUTH_TOKEN_KEY) || '';
  const h = Object.assign({}, extra || {});
  if (t) h['Authorization'] = 'Bearer ' + t;
  return h;
}

/**
 * WebSocket auth: browsers can't set an Authorization header on a WS, so the
 * JWT rides in the Sec-WebSocket-Protocol list — the server
 * (auth.authenticate_websocket) reads ['bearer', <token>] and accepts with
 * subprotocol 'bearer'. Keeps the token out of URLs/access logs. Null when
 * logged out — NC.ws.managedSocket's contract for "don't even try" (fires
 * onAuthMissing instead of a doomed handshake loop).
 */
export function wsAuthProtocols(): string[] | null {
  const t = localStorage.getItem(AUTH_TOKEN_KEY) || '';
  return t ? ['bearer', t] : null;
}
